import { render, staticRenderFns } from "./Idp.vue?vue&type=template&id=7536678d&scoped=true&"
import script from "@/views/Groups/Tabs/Idp.ts?vue&type=script&lang=ts&"
export * from "@/views/Groups/Tabs/Idp.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Groups/Tabs/idp.scss?vue&type=style&index=0&id=7536678d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7536678d",
  null
  
)

export default component.exports